export const ROUTES = {
    HOME: '/',
    REGISTER: '/register',
    SUCCESS: '/success',
    VIEW_ITINERARY: '/view-itinerary'
};
